import React from "react";
import DashboardDataTag from "./DashboardDataTag";
import DataTagLayout from "./DataTagLayout";
import DataEstate from "./DataEstate/DataEstate";

function DataGuardHomePage() {
   const tabs = [
    {
      name: "Enterprise Dashboard",
      component: <DashboardDataTag />
    },
    {
      name: "Data Estate",
      component: <DataEstate />
    },
  ];
  return <div><DataTagLayout tabs={tabs}/></div>;
}

export default DataGuardHomePage;
